import routeMapper from "../router/routeMapper";

const wordMap = {
	"Å": "aa"
};

export default {
	redirectToShop(component) {
		if (window.universalLinks) {
			window.universalLinks.subscribe("shopSelection", function (eventData) {
				const query = eventData.params || {};
				component.$router.push({
					name: routeMapper.routeNames.shopSelection,
					query
				});
			});
		}
	},
	listShops: function (self, shops, tenantConfig, requireLinkText = false) {
		return shops.map((shop, key) => {
			const searchAddress = shop.shopAddress.smileyAddress ?
				shop.shopAddress.smileyAddress :
				shop.shopAddress.street.split(/[0-9]+/)[0].trim();
			const smileyUrlExtension = `?k=${tenantConfig.tenantName} ${searchAddress}`;
			return {
				key: key,
				name: `${shop.shopName}`,
				address: `${shop.shopAddress.street}, ${shop.shopAddress.zip} ${shop.shopAddress.city}`,
				linkText: requireLinkText ? self.$t("helper.shopHelper.smileyReportsLinkText") : null,
				linkUrl: encodeURI(`${tenantConfig.smileyReportsSearchUrl}/${smileyUrlExtension}`),
				offersHeatableFood: shop.offersHeatableFood,
				tenantName: tenantConfig.tenantName
			};
		});
	},
	dispatchAndListShops: function (self, tenantConfig, action) {
		return self.$store.dispatch(action).then(shops => {
			self.shops = this.listShops(self, shops, tenantConfig);
		});
	},
	filterShops: function (self, shops, searchValue, searchKeys) {
		const searchData = searchValue.trim().split(" ").filter(el => el.trim());

		if (searchValue.length > 0) {
			return self.shops.filter((shop) => {
				return searchKeys.reduce((carry, key) => {
					const keyFound = Object.keys(wordMap).find(key => {
						return searchValue.toLowerCase().startsWith(key.toLowerCase());
					});

					if (keyFound) {

						const newSearchValue = searchValue.toLowerCase()
							.replace(
								keyFound.toLowerCase(),
								wordMap[keyFound]
							);
						return carry || (
							(shop[key].toLowerCase().search(searchValue) > -1) ||
							(shop[key].toLowerCase().search(newSearchValue) > -1)
						);
					} else {

						const excludedWords = ["føtex", "foetex", "bilka"];
						const itemFound = searchData.find(searchText => {
							const searchTextLowCase = searchText.toLowerCase();
							if (searchData.length > 1) {
								return !excludedWords.includes(searchTextLowCase) ? shop[key].toLowerCase().search(searchTextLowCase) > -1 : null;
							}
							return shop[key].toLowerCase().search(searchTextLowCase) > -1;
						});

						return carry || itemFound;
					}
				}, false);
			})
				.sort((first, second) => {
					return second.name.toLowerCase().includes(searchValue.toLowerCase()) ? 0 : -1;
				});
		} else {
			return self.shops;
		}

		//føtex vejle
	},

	registerSynonimPair: function (key, value) {
		wordMap[key] = value;
	},

	createComponentShop(shop) {
		return {
			id: shop.id,
			shopName: shop.shopName,
			deliveryMethods: shop.deliveryMethods,
			shopAddress: `
				${shop.shopAddress.street},
				${shop.shopAddress.zip}
				${shop.shopAddress.city}`,
			offersHeatableFood: shop.offersHeatableFood,
			shopOptions: shop.shopOptions,
			shopWorkingHours: shop.shopWorkingHours
		};
	}

};
